<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Undone Assignments</h2>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="title" header="Title" />
        <PrimeColumn field="subject" header="Subject" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        label="Write"
                        icon="pi pi-bar"
                        class="p-button-rounded p-button-text"
                        @click="gotoWrite(slotProps.data)"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
  
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref} from 'vue';
import { useRouter } from "vue-router";

export default {
    name:"AssignmentList",
    setup(){
        const router = useRouter();
        const state=reactive({loading:true})
        const list = ref([])
        const globalFilter=ref("")

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            call({
                url:urls.subject,
                data:{getActiveAssignmentList:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function gotoWrite(row){
            router.push({ name: 'writeassignment', params:{id:row.id}});
        }
        
        return {list,globalFilter, state,gotoWrite}
    }
}
</script>